export class AddOn {
  _id = ''
  title = ''
  price = ''

  constructor () {
    this._id = 'CUSTOM'
  }
}
